import { getDataClient } from "@/lib/dataClient";
import { useDataQuery, getCurrentUserId } from "@/hooks/useDataQuery";

export interface UsageStat {
  label: string;
  used: string;
  total: string;
  percent: number;
}

export function usePackageUsage() {
  return useDataQuery<UsageStat[]>(async () => {
    const dataClient = getDataClient();
    const userId = await getCurrentUserId();
    if (!userId) return [];

    const [vp, exams, sessions] = await Promise.all([
      dataClient.from("video_progress").select("progress").eq("user_id", userId),
      dataClient.from("exam_attempts").select("id").eq("user_id", userId),
      dataClient.from("study_sessions").select("minutes").eq("user_id", userId),
    ]);

    const videosWatched = (vp.data ?? []).filter((v: { progress: number }) => v.progress > 0).length;
    const examCount = (exams.data ?? []).length;
    const sessionCount = (sessions.data ?? []).length;

    return [
      { label: "Video ders izleme", used: String(videosWatched), total: "Sınırsız", percent: 0 },
      { label: "Çalışma oturumu", used: String(sessionCount), total: "Sınırsız", percent: 0 },
      { label: "Deneme tamamlandı", used: String(examCount), total: "Sınırsız", percent: 0 },
    ];
  });
}